import React, { Component, PropTypes } from 'react';
import StoreSection from './StoreSection';
import StoreEditor from './StoreEditor';
import { StoreOverviewActions } from 'actions';
import { DialogContent } from 'components/Dialog';
import { Colors, Units } from 'Css';
import CoursioLogo from 'components/CoursioLogo';
import { FormattedMessage } from 'react-intl';
import PurchaseDialog from 'containers/Store/PurchaseDialog';
import GiftDialog from 'containers/Store/GiftDialog';
import shallowEqual from 'shallowequal';

const css = oxygenCss({
  root: {
    overflow: 'hidden',
    '@phone': {
      overflow: 'initial'
    }
  },
  copyright: {
    color: Colors.material.grey[400].hex,
    lineHeight: '48px',
    textAlign: 'center',
    marginTop: Units.base,
    padding: Units.base
  },
  coursioLogoContainer: {
    backgroundColor: Colors.fullWhite,
    color: Colors.material.grey[400].hex,
    lineHeight: '48px',
    textAlign: 'center',
    padding: Units.base * 2
  }
});

class StoreLayout extends Component {
  static propTypes = {
    layout: PropTypes.object,
    mode: PropTypes.string,
    searchText: PropTypes.string,
    selectedSection: PropTypes.object,
    ownerName: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  selectSection = section => {
    if (this.props.mode === 'editor') {
      StoreOverviewActions.selectSection(section.id);
    }
  };

  render() {
    const {
      layout,
      selectedSection,
      ownerName,
      storeName,
      userLocale,
      history,
      ...other
    } = this.props;
    const { getIntlMessage } = this.context;
    const { sections } = layout;
    return (
      <DialogContent>
        <div className={css.root}>
          {sections.map(section => {
            return (
              <StoreEditor
                onTouchTap={this.selectSection.bind(this, section)}
                mark={false}
                key={section.id}
                selected={selectedSection && selectedSection.id === section.id}
              >
                <StoreSection ownerName={ownerName} {...section} {...other} />
              </StoreEditor>
            );
          })}
        </div>
        <div className={css.copyright}>
          <FormattedMessage
            message={getIntlMessage('copyright')}
            year={new Date().getFullYear()}
            name={ownerName}
          />
        </div>
        <div className={css.coursioLogoContainer}>
          <CoursioLogo
            initialFill={Colors.material.grey[400].hex}
            size={100}
            width="48px"
          />
          <br />
          <FormattedMessage
            message={getIntlMessage('poweredBy')}
            engine={'Coursio'}
          />
        </div>
        <GiftDialog />
      </DialogContent>
    );
  }
}

export default StoreLayout;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreLayout.js